import React from "react"
import { Flex, FlexProps, Box } from "@chakra-ui/core"
import Body from "../typography/Body"

type CompareOptionProps = FlexProps & {
  label: string
  value: boolean
}

export default function CompareOption({
  label,
  value,
  ...props
}: CompareOptionProps) {
  const color = value ? "primary" : "dawn"
  return (
    <Flex flexDir="column" {...props}>
      <Box
        backgroundColor={color}
        borderRadius="0.5rem"
        height="0.25rem"
        w="100%"
        mb="0.5rem"
      />
      <Body textAlign="center" size="xs" color={color}>
        {label}
      </Body>
    </Flex>
  )
}
